export default __webpack_public_path__ + "static/media/cuida_illustration.9d2a0c5e.png";